import { render, staticRenderFns } from "./UnitPlanNavigation.vue?vue&type=template&id=8bac8b1e&scoped=true&"
import script from "./UnitPlanNavigation.vue?vue&type=script&lang=js&"
export * from "./UnitPlanNavigation.vue?vue&type=script&lang=js&"
import style0 from "./UnitPlanNavigation.vue?vue&type=style&index=0&id=8bac8b1e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bac8b1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/wbreu/Documents/code/personal/the-unit-planner/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8bac8b1e', component.options)
    } else {
      api.reload('8bac8b1e', component.options)
    }
    module.hot.accept("./UnitPlanNavigation.vue?vue&type=template&id=8bac8b1e&scoped=true&", function () {
      api.rerender('8bac8b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnitPlanNavigation.vue"
export default component.exports